import { SectionHeading, SectionLabel } from "./Section";

export function Contact() {
  return (
    <section id="contact" className="relative py-32">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_100%,oklch(0.25_0.18_250/0.20),transparent_60%)]" />
      <div className="relative mx-auto max-w-3xl px-6 text-center">
        <SectionLabel>Contact</SectionLabel>
        <SectionHeading>
          Let's Build
          <br />
          The Future.
        </SectionHeading>
        <p className="mx-auto mt-6 max-w-md text-muted-foreground">
          Open to conversations on AI, SaaS, ambitious ideas, and early collaborations.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <a
            href="https://www.linkedin.com/in/nithin-devadiga-129016407"
            target="_blank"
            rel="noopener noreferrer"
            className="glass inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium transition-all hover:bg-white/10"
          >
            LinkedIn ↗
          </a>
          <a
            href="mailto:nithindevadiga920@gmail.com"
            className="inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground transition-all hover:scale-[1.02]"
          >
            Email
          </a>
        </div>
      </div>
    </section>
  );
}
